import { useEffect, useState, useRef, useCallback } from "react";

import BulmaTagsInput from '@creativebulma/bulma-tagsinput';

const TagsInput = ({ id, label, name, placeholder, data, onChange, value = [], options, className = '' }) => {

    const tagsInputRef = useRef();
    const [element, setElement] = useState(null);

    const init = useCallback(() => {
        const e = new BulmaTagsInput(tagsInputRef.current, {
            source: data,
            freeInput: false,
            caseSensitive: false,
            allowDuplicates: false,
            ...options
        });

        let v = value;
        if (!Array.isArray(v)) v = value.split(',');

        e.add(v);

        e.on('after.add', (d) => {
            const value = e.options.maxTags === 1 ? d.item : e.items;

            if (onChange) {
                onChange({ target: { name, value } });
            }
        });

        e.on('after.remove', () => {
            const value = e.items;

            if (onChange) {
                onChange({ target: { name, value } });
            }
        });

        setElement(e);
    }, [data, onChange, name, options, value]);

    useEffect(() => {
        if (!element) {
            init();
        }

        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [element]);

    return (
        <div className="field">
            {label ? <label className="label">{label}</label> : null}
            <div className="control">
                <input ref={tagsInputRef} className={`input ${className}`} id={id} type="text" placeholder={placeholder} />
            </div>
        </div>
    );
}

const ObjectTagsInput = ({ itemText, itemValue, options, onChange, ...props }) => {
    const inputOptions = {
        itemText,
        itemValue,
        ...options
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (onChange) {
            onChange({ target: { name, value: value[itemValue] } });
        }
    }

    return (
        <TagsInput {...props} onChange={handleChange} options={inputOptions} />
    );
}

export { TagsInput, ObjectTagsInput };
